// Persists the service a visitor selected (from a service page) so the estimate form
// can preselect it and the CRM retains which service/page the lead came from.
const KEY = 'mmt_estimate_service';

export function setEstimateService(data) {
  try { sessionStorage.setItem(KEY, JSON.stringify(data || {})); } catch (e) { /* noop */ }
}

export function getEstimateService() {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch (e) { return null; }
}

export function clearEstimateService() {
  try { sessionStorage.removeItem(KEY); } catch (e) { /* noop */ }
}
